import type { JSX } from "react";
import { useTranslations } from "next-intl";
import { TabSwitcher } from "../molecules/TabSwitcher";
// import Trans from "next-translate/Trans";
import { StaticRoutes } from "@routes";
import { join } from "path-browserify";
import { color } from "@styles";
import { Anchor } from "components/atoms/Anchor";
import { string } from "yup";

interface Props {
  title?: string;
  content?: string;
  tabs?: Tab[];
}

export interface Tab {
  title: string;
  heading?: string | JSX.Element;
  content?: string | JSX.Element;
  image?: string | JSX.Element;
  alt?: string;
  url?: string;
  callToAction?: string;
  footnote?: string;
}

export const TabSwitcherProducts = ({ title, content, tabs }: Props) => {
  const t = useTranslations("shared/tab-switcher");

  return (
    <TabSwitcher
      id="tabswitcherproducts"
      title={title || t<string>("title")}
      content={content || t<string>("content")}
      tabs={
        tabs
          ? tabs
          : [
              {
                title: t<string>("tabs.tab1.title"),
                heading: t<string>("tabs.tab1.heading"),
                content: t<string>("tabs.tab1.content"),
                image: (
                  <img src={t<string>("tabs.tab1.img-src")} alt={t<string>("tabs.tab1.img-alt")} />
                ),
                alt: t<string>("tabs.tab1.img-alt"),
                url: t<string>("tabs.tab1.url"),
              },
              {
                title: t<string>("tabs.tab2.title"),
                heading: t<string>("tabs.tab2.heading"),
                content: (
                  <>
                    {t.rich("tabs.tab2.content", {
                      yucoin: (chunks) => (
                        <Anchor
                          key="tabs.tab2.content.yucoin"
                          color={color.P100}
                          href={join(StaticRoutes.blog, "what-is-yucoin-and-how-does-it-work/")}
                        >
                          {chunks}
                        </Anchor>
                      ),
                    })}
                  </>
                ),
                image: (
                  <img src={t<string>("tabs.tab2.img-src")} alt={t<string>("tabs.tab2.img-alt")} />
                ),
                alt: t<string>("tabs.tab2.img-alt"),
                url: t<string>("tabs.tab2.url"),
              },
              {
                title: t<string>("tabs.tab3.title"),
                heading: t<string>("tabs.tab3.heading"),
                content: t<string>("tabs.tab3.content"),
                image: (
                  <img src={t<string>("tabs.tab3.img-src")} alt={t<string>("tabs.tab3.img-alt")} />
                ),
                alt: t<string>("tabs.tab3.img-alt"),
                url: t<string>("tabs.tab3.url"),
              },
              {
                title: t<string>("tabs.tab4.title"),
                heading: t<string>("tabs.tab4.heading"),
                content: t<string>("tabs.tab4.content"),
                image: (
                  <img src={t<string>("tabs.tab4.img-src")} alt={t<string>("tabs.tab4.img-alt")} />
                ),
                alt: t<string>("tabs.tab4.img-alt"),
                url: t<string>("tabs.tab4.url"),
              },
            ]
      }
    />
  );
};
